// extracted by mini-css-extract-plugin
export default {"button-wrapper":"_1K1Pi","buttonWrapper":"_1K1Pi","dot":"_2aBmC"};